import type { FC, ReactNode } from "react";
import { View } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { Text } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";

export interface ScheduleRowProps {
  readonly label: string;
  readonly helperText?: string | undefined;
  /** The row's control, shown on the right; it wraps below the label when the row is narrow. */
  readonly children: ReactNode;
}

/** One bordered row of the schedule: label and helper on the left, control on the right. */
export const ScheduleRow: FC<ScheduleRowProps> = ({ label, helperText, children }) => (
  <View style={styles.row}>
    <View style={styles.text}>
      <Text textStyle="sm/medium" color="text">
        {label}
      </Text>
      {helperText !== undefined && (
        <Text textStyle="xs/regular" color="textMuted">
          {helperText}
        </Text>
      )}
    </View>
    <View style={styles.control}>{children}</View>
  </View>
);

const styles = StyleSheet.create((theme) => ({
  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing.xl,
    paddingVertical: theme.spacing.xl,
    paddingHorizontal: theme.spacing.lg,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    borderRadius: theme.spacing.md,
    backgroundColor: theme.colors.surfaceCard,
  },
  text: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 120,
    gap: theme.spacing.xxs,
  },
  control: {
    flexShrink: 1,
    maxWidth: "100%",
  },
}));
